import PropTypes from 'prop-types';

import { parseTitle } from '../../../utils/title-parser';

const BlogPageHeader = (props) => {
    const { title, subheading } = props;   
    const isMainHeaderOne = true;

    return (
        <div className='container-root container-root-maxWidthLg blog-page-header-container'>
            {parseTitle(title, 'blog_header', isMainHeaderOne)}
            <p className='blog-page-header-sub-heading'>
                {subheading}
            </p>
        </div>
    );
};

export default BlogPageHeader;

BlogPageHeader.propTypes = {
    title: PropTypes.string,
    subheading: PropTypes.string,
};

